<template>
<div class="chapter">
<div class="inner_page">
<p class="center1"><a id="page_2"></a><em>Also by Jack Womack</em></p>
<p class="center">AMBIENT<br/>TERRAPLANE<br/>HEATHERN<br/>ELVISSEY<br/>LET’S PUT THE FUTURE BEHIND US<br/>GOING, GOING, GONE</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?6cae3f6d